// apps/client/src/net/handlers/digging.ts (M2-T09) — the 'digging' layer follows your personal dig spots (snapshot, return outdoors,
// `you.patch`), and other residents' digs play the dig animation on their avatar.
import { useGame } from '../../state/store';
import { digLayerOf } from '../../world/digging';
import type { NetHandlers } from '../../game/game';

export const handlers: NetHandlers = {
  onSnapshot(snap, game) { digLayerOf(game)?.set(snap.you.yields.digSpots); },
  onSpace(space, game) { if (space.kind === 'out') digLayerOf(game)?.set(useGame.getState().you?.yields.digSpots ?? []); },
  onPatch(patch, game) { if (patch.yields?.digSpots) digLayerOf(game)?.set(patch.yields.digSpots); },
  events: {
    'dig.dug': (e, game) => {
      if (e.r === useGame.getState().you?.resident) return;          // your own crack updates through the patch
      game.avatarOf(e.r)?.play('dig');
    },
  },
};
